import React from 'react';
import { 
    BodyContainer, 
    Container} from "../components/StyledComponents/StyledComponents";
import Navigation from '../components/Navigation/Navigation.jsx';
import Footer from '../components/Footer/Footer.jsx';
import ProgressBar from '../components/ProgressBar/ProgressBar';
import ArticleItem from '../components/ArticleItem/ArticleItem';

import { useEffect, useState } from 'react';
import { db } from '../firebase.js';
import { collection, onSnapshot } from "firebase/firestore"; 

const Blog = () => {

    const [list, setList] = useState([]);
    const [input, ]=useState('');

    const tags = ['health', 'urban', 'transportation', 'sustainability', 'other']
    const titles = ['Global Health', 'Urban Issues', 'Transportation', 'Sustainability', 'Other']

    useEffect(() => {
        onSnapshot(collection(db, 'projects'), (snapshot) => {
            snapshot.docs.map(doc => {
                let data = doc.data();
                setList(prev => [...prev, data]);//snapshot.docs.map(doc => doc.data()));
            })
        })
        },[input]);

    return(
        <>
        <ProgressBar/>
        <Navigation page="about" />
        <BodyContainer style={{marginTop: "10%"}}>
				<h1>My Thoughts...</h1>
                <p>I write about health, urban issues, and sustainability. Check out what I've been thinking about below!</p>
                {/* AI Section - displayed first */}
                <div>
                    <h3>AI</h3>
                    <Container>
                        {list.sort((a,b) => b.timestamp - a.timestamp).map((project) => {
                            if (project.tags && project.tags.includes("ai")) {
                                return (
                                    <ArticleItem
                                        route={project.route}
                                        thumbnail={project.image}
                                        subtitle={project.subtitle}
                                        title={project.title}
                                        date={project.date}
                                        description={project.description}
                                        hasData={project.tags.includes("statistics")}
                                    />
                                );    
                            }
                        })}
                    </Container>
                </div>
                {tags.map((tag, i) => {
                    return (
                    <div>
                    <h3>{titles[i]}</h3>
                    <Container>
                        {list.sort((a,b) => b.timestamp - a.timestamp).map((project) => {
                            if ((tags[i] === 'other' && project.tags && 
                                !project.tags.includes("urban") && 
                                !project.tags.includes("sustainability") && 
                                !project.tags.includes("transportation") &&
                                !project.tags.includes("health") &&
                                !project.tags.includes("ai")) ||
                            (project.tags && project.tags.includes(tags[i]) && !project.tags.includes("ai"))) {
                        return (
                            <ArticleItem
                                route={project.route}
                                thumbnail={project.image}
                                subtitle={project.subtitle}
                                title={project.title}
                                date={project.date}
                                description={project.description}
                                hasData={project.tags.includes("statistics")}
                            />
                        );    
                        }})}
                    </Container>
                    </div>
                )})}
        </BodyContainer>
        <Footer/>
        </>
    );
}

export default Blog;
